<template>
    <div
        class="testimonials"
        v-if="data?.items?.length"
    >
        <div>
            <Title
                :title="data?.title"
                :description="data?.description"
            />
            <Carousel
                :autoPlay="false"
                :pagination="true"
                :draggable="true"
                :autoPlayTime="1000"
                :numberOfItems="data.items.length"
                :numberOfItemsToShow="3"
                :numberOfItemsToShowCustom="[[1, 1], [559, 2], [879, 3]]"
            >
                <Slide
                    v-for="item in data.items"
                    v-bind:key="item?.documentId"
                >
                    <div class="card">
                        <img
                            v-if="item?.image?.url"
                            :src="item?.image?.url"
                            :alt="item?.image?.alternativeText || item?.author || 'Bzioup testimonial'"
                        />
                        <div class="blockquote">
                            <p
                                v-if="item?.quote"
                                class="quote"
                            >{{ item?.quote }}</p>
                            <div
                                v-if="item?.author"
                                class="quote-by"
                            >{{ item?.author }}</div>
                        </div>
                    </div>
                </Slide>
            </Carousel>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Text/Title.vue'
import Slide from '@/components/Noice/Slide.vue'
import Carousel from '@/components/Noice/Carousel.vue'

export default {
    name: 'TestimonialsImage',
    components: {
        Title,
        Slide,
        Carousel
    },
    props: {
        data: Object
    }
}
</script>

<style lang="scss" scoped>
.testimonials .carousel {
    padding: 30px 10px 20px;
    margin: 0 auto;
    max-width: 1080px;
}

.testimonials :deep(.slide) {
    padding: 0 12px;
}

.testimonials :deep(.slide:nth-child(odd) .card) {
    transform: rotate(-1.5deg);
}

.testimonials :deep(.slide:nth-child(even) .card) {
    transform: rotate(1.2deg);
}

.card {
    position: relative;
    margin: 40px auto 0;
    max-width: 320px;
    padding: 64px 26px 26px;
    border-radius: 18px;
    background: var(--bzioup-bg-color-A);
    box-shadow: 0 14px 34px rgba(8, 20, 72, 0.1);
    transition: transform 260ms cubic-bezier(0.2, 0.8, 0.3, 1) !important;
}

.card:hover {
    transform: rotate(0) translateY(-6px) !important;
}

.card img {
    position: absolute;
    top: -40px;
    left: 50%;
    width: 84px;
    height: 84px;
    margin-left: -42px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid var(--bzioup-bg-color-A);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    filter: grayscale(100%);
    transition: filter 260ms ease;
}

.card:hover img {
    filter: none;
}

.blockquote {
    white-space: break-spaces;
    color: var(--bzioup-color-Z);
}

.quote {
    position: relative;
    margin: 0;
    font-size: 17px;
    line-height: 1.45;
    font-family: Georgia, 'Times New Roman', serif;
    font-style: italic;
}

.quote::before {
    content: '\201C';
    position: absolute;
    top: -34px;
    left: -6px;
    font-size: 72px;
    line-height: 1;
    font-family: Georgia, serif;
    color: var(--bzioup-color-pink);
    opacity: 0.6;
}

.quote-by {
    margin-top: 16px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: var(--bzioup-color-pink);
}

.quote-by::before {
    content: '- ';
}
</style>
